'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'bath';
var width = 512;
var height = 512;
var aliases = [128705,"bathtub"];
var unicode = 'f2cd';
var svgPathData = 'M85.3 16C64.7 16 48 32.7 48 53.3L48 272l416 0 16 0 24 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-24 0-16 0L48 288l-16 0L8 288c-4.4 0-8-3.6-8-8s3.6-8 8-8l24 0L32 53.3C32 23.8 55.8 0 85.3 0c14.1 0 27.7 5.6 37.7 15.6l32.1 32.1C167.4 37.9 183 32 200 32c23.1 0 43.7 10.9 56.9 27.8l1.5-1.5c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-104 104c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l1.5-1.5C138.9 147.7 128 127.1 128 104c0-17 5.9-32.6 15.7-44.9L111.6 26.9c-7-7-16.5-10.9-26.3-10.9zM32 320l16 0 0 48c0 53 43 96 96 96l224 0c53 0 96-43 96-96l0-48 16 0 0 48c0 38.1-19 71.7-48 91.9l0 44.1c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-34.8c-14.5 6.9-30.8 10.8-48 10.8l-224 0c-17.2 0-33.5-3.9-48-10.8L96 504c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-44.1C51 439.7 32 406.1 32 368l0-48zM200 48c-30.9 0-56 25.1-56 56c0 18.7 9.2 35.3 23.3 45.4l78.2-78.2C235.3 57.2 218.7 48 200 48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBath = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;